/**
 * Breadcrumb Collection Tracker
 * Salva in localStorage l'ultima PLP visitata (handle + titolo)
 * e aggiorna il breadcrumb sui PDP in base al percorso dell'utente.
 * Fallback: prima collezione del prodotto
 */
(function() {
  'use strict';

  var STORAGE_KEY_COLLECTION = 'breadcrumb_collection';
  var STORAGE_KEY_COLLECTION_TITLE = 'breadcrumb_collection_title';

  // Parsa le collezioni del prodotto dal data attribute (formato: handle|title,handle|title)
  function parseProductCollections(dataString) {
    if (!dataString) return [];
    return dataString.split(',').map(function(entry) {
      var parts = entry.split('|');
      return { handle: parts[0], title: parts[1] || parts[0] };
    });
  }

  // Salva la collezione visitata su PLP
  function trackCollectionFromPLP() {
    var container = document.querySelector('.breadcrumbs-container[data-is-plp="true"]');
    if (!container) return;
    
    var collectionHandle = container.dataset.collectionHandle || '';
    var collectionTitle = container.dataset.collectionTitle || '';
    
    if (!collectionHandle) return;
    
    localStorage.setItem(STORAGE_KEY_COLLECTION, collectionHandle);
    localStorage.setItem(STORAGE_KEY_COLLECTION_TITLE, collectionTitle);
  }

  // Applica il breadcrumb su PDP
  function applyCollectionBreadcrumb() {
    var container = document.querySelector('.breadcrumbs-container[data-is-pdp="true"]');
    if (!container) return;

    var productCollections = parseProductCollections(container.dataset.productCollections);
    if (productCollections.length === 0) return;

    var savedCollection = localStorage.getItem(STORAGE_KEY_COLLECTION);
    var savedTitle = localStorage.getItem(STORAGE_KEY_COLLECTION_TITLE);
    
    var targetHandle = '';
    var targetTitle = '';

    // Cerca se la collezione salvata è tra quelle del prodotto
    if (savedCollection) {
      for (var i = 0; i < productCollections.length; i++) {
        if (productCollections[i].handle === savedCollection) {
          targetHandle = savedCollection;
          targetTitle = savedTitle || productCollections[i].title;
          break;
        }
      }
    }

    // Fallback: usa la prima collezione del prodotto
    if (!targetHandle && productCollections.length > 0) {
      targetHandle = productCollections[0].handle;
      targetTitle = productCollections[0].title;
    }

    if (!targetHandle) return;

    var homeLink = container.querySelector('.breadcrumb-homepage');
    if (!homeLink) return;

    // Rimuovi breadcrumb esistenti (renderizzati da Liquid)
    var existingCategory = container.querySelector('.breadcrumb-category');
    var existingType = container.querySelector('.breadcrumb-type');
    
    if (existingCategory) existingCategory.remove();
    
    if (existingType) {
      // Aggiorna il breadcrumb esistente
      var span = existingType.querySelector('span[data-handle]');
      existingType.href = '/collections/' + targetHandle;
      existingType.title = targetHandle;
      // Aggiungi underline per indicare che è cliccabile
      existingType.classList.add('tw-underline');
      if (span) {
        span.dataset.handle = targetHandle;
        span.textContent = targetTitle;
      }
    } else {
      // Crea separatore (non cliccabile, non sottolineato)
      var separator = document.createElement('span');
      separator.className = 'breadrumbs__separator tw-text-fs-14 tw-mr-[.5rem]';
      separator.textContent = '›';
      
      // Crea nuovo breadcrumb (link cliccabile)
      var newBreadcrumb = document.createElement('a');
      newBreadcrumb.href = '/collections/' + targetHandle;
      newBreadcrumb.title = targetHandle;
      newBreadcrumb.className = 'pdp-breadcrumb breadcrumb-type tw-text-[#45423d] tw-tracking-normal tw-underline hover:tw-text-[#7a7a7a]';
      newBreadcrumb.innerHTML = '<span data-handle="' + targetHandle + '">' + targetTitle + '</span>';

      homeLink.parentNode.insertBefore(separator, homeLink.nextSibling);
      homeLink.parentNode.insertBefore(newBreadcrumb, separator.nextSibling);
    }
  }

  // Init
  trackCollectionFromPLP();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCollectionBreadcrumb);
  } else {
    applyCollectionBreadcrumb();
  }
})();
